import { environment } from '../../environments/environment';

export const apiEndpoints = {
    //session
    initiate: () => environment.host + `/v1/auth/session/initiate`,
    refresh: () => environment.host + `/v1/auth/session/refresh`,
    //activation
    initiateActivate: () => environment.host + `/v1/activation/initiate`,
    activateStatus: (activationId: string) => environment.host + `/v1/activation/${activationId}/status`,

    //transaction
    updatePaytment: (correlationId:string) => environment.host + `/v1/transactions/update/${correlationId}`,
    completePayment: (correlationId:string) => environment.host + `/v1/transactions/complete-transaction/${correlationId}`,
    getPayment: (transactionId:string,statusMode:string) => environment.host + `/v1/transactions/${transactionId}/${statusMode}`,
    getOpenPayments: () => environment.host + `/v1/transactions/open-transactions`,
    
    //orchestrator
    initiateOrchestrator: () => environment.host + `/v1/dos/orchestrate`,

    thunesStream:(correlatorId:string) => environment.host + `/thunes/${correlatorId}/stream`,
    thunesWebhook:() => environment.host + `/webhooks/thunes`,
    getConsentStatus:(customerMsisdn:string) => environment.host + `/config/diaspora-profile/consent/${customerMsisdn}`,
    getConsentStatus1:(customerMsisdn:string) => environment.host + `/config/diaspora-profile/consent/${customerMsisdn}`,
    updateConsentStatus:(customerMsisdn:string) => environment.host + `/diasporawallet/v1/activation/update-consent`
    
};
